import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';
import { ButtonWithPopup } from '../../common/ButtonWithPopup';
import { PopupContent, PopupSection, PopupOption, PopupDivider } from '../../common/Popup';
import { getAuth, signOut, setPersistence, GoogleAuthProvider, browserLocalPersistence, signInWithPopup } from "firebase/auth";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setDialogOpen, setLoggedInUser } from '../../../store/Actions';
import { MyAvatar } from '../../common/MyAvatar';
import '../TopHeader.scss';


export function AccountButton() {
    const [popupOpen, setPopupOpen] = useState(true);
    const auth = getAuth();
    const loggedInUser = useSelector(state=>state.loggedInUser);
    const loggedInUserAccount = useSelector(state=>state.loggedInUserAccount)
    const viewingUserAccount = useSelector(state=>state.viewingUserAccount)
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const viewingLoggedInUser = viewingUserAccount && loggedInUserAccount && viewingUserAccount.username === loggedInUserAccount.username;

    const login = () => {
        setPersistence(auth, browserLocalPersistence).then(()=>{
          signInWithPopup(auth, new GoogleAuthProvider())
          .catch((error) => {
            console.log('error logging in:', error)
          });
        });
      }

    const signout = () => {
        dispatch(setLoggedInUser(null));
        signOut(auth)
        setPopupOpen(false);
    }

    const goToProfile = () => {
        navigate({
            pathname: `/${encodeURIComponent(loggedInUserAccount.username)}`,
            search: location.search,
        });
    }

    const buttonComponent = (
        <div className="account-avatar-button">
            <MyAvatar
                userAccount={loggedInUserAccount}
                style={{ width: 38, height: 38 }}
            />
            {/* <div className="account-avatar-button__notification">20+</div> */}
            <div className="account-avatar-button__chevron">
                <KeyboardArrowDownIcon/>
            </div>
        </div>
    );

    const popupComponent = (
        <PopupContent style={{ width: 240 }}>
            {!loggedInUser && (
                <PopupOption icon={<LoginIcon fontSize="small"/>} title="Sign In" onClick={() => login()} />
            )}
            {loggedInUser && (
                <>
                    {!viewingLoggedInUser && (
                        <PopupSection>
                            <PopupOption
                                icon={<PersonIcon fontSize="small"/>}
                                title="My Profile"
                                onClick={() => { goToProfile(); setPopupOpen(false); }}
                            />
                            <PopupDivider/>
                        </PopupSection>
                    )}
                    <PopupSection>
                        <PopupOption icon={<SettingsIcon fontSize="small"/>} title="My Account" onClick={() => { dispatch(setDialogOpen('Account')); setPopupOpen(false); }} />
                        <PopupOption icon={<LogoutIcon fontSize="small"/>} title="Sign Out" variant="danger" onClick={signout} />
                    </PopupSection>
                </>
            )}
        </PopupContent>
    );


  return (
    <ButtonWithPopup
      popupOpen={popupOpen}
      setPopupOpen={setPopupOpen}
      toggleOnClick
      buttonStyle={{
        height: '38px',
        width: '38px',
        padding: 0,
        background: 'transparent',
        boxShadow: 'none',
        border: 'none',
        overflow: 'visible',
      }}
      buttonComponent={buttonComponent}
      popupComponent={popupComponent}
      popupStyle={{marginLeft:'-20px'}}
    />
  );
}
